import { MockedRequest, RequestHandler, rest, restContext } from 'msw';
import eveOauth2Token from '../fixtures/tokens';

const handlers: RequestHandler<MockedRequest, typeof restContext>[] = [
  rest.post(`${process.env.PUBLIC_URL}/api/token_exchange/oauth/token`, (req, res, ctx) => {
    return res(ctx.json(eveOauth2Token));
  }),
];

export default handlers;
